import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  HostListener,
  Renderer2,
} from '@angular/core';

@Component({
  selector: 'aditya-mobile-recharge',
  templateUrl: './mobile-recharge.component.html',
  styleUrls: ['./mobile-recharge.component.css']
})
export class MobileRechargeComponent implements AfterViewInit {

  @ViewChild('tabList') tabList!: ElementRef<HTMLUListElement>;
  @ViewChild('wrapperNav') wrapperNav!: ElementRef<HTMLDivElement>;

  tabs = ['Home', 'Profile', 'Contact', 'Tab4', 'Tab5', 'Tab6', 'Tab7', 'Tab8', 'Tab9', 'Tab10', 'Tab11', 'Tab12', 'Tab13'];
  activeIndex = 0;

  scrollBarWidths = 40;

  constructor(private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.reAdjust();
  }

  @HostListener('window:resize')
  onResize() {
    this.reAdjust();
  }

  widthOfList(): number {
    const links = this.tabList.nativeElement.querySelectorAll('li a');
    let width = 0;
    links.forEach(link => {
      width += (link as HTMLElement).offsetWidth;
    });
    return width;
  }

  getLeftPos(): number {
    const listLeft = this.tabList.nativeElement.getBoundingClientRect().left;
    const wrapperLeft = this.wrapperNav.nativeElement.getBoundingClientRect().left;
    return listLeft - wrapperLeft;
  }

  widthOfHidden(): number {
    const wrapperWidth = this.wrapperNav.nativeElement.offsetWidth;
    const hidden = wrapperWidth - this.widthOfList() - this.getLeftPos() - this.scrollBarWidths;
    return hidden;
  }

  scrollRight() {
    const moveAmount = 100; // or any number like 100px
    const list = this.tabList.nativeElement;

    list.style.transition = 'left 0.5s';
    list.style.position = 'relative';

    const currentLeft = parseInt(list.style.left || '0', 10);
    const newLeft = currentLeft - moveAmount;

    this.renderer.setStyle(list, 'left', `${newLeft}px`);
    this.reAdjust();
  }

  scrollLeft() {
    const moveAmount = 100; // move 100px to right
    const list = this.tabList.nativeElement;

    list.style.transition = 'left 0.5s';
    list.style.position = 'relative';

    const currentLeft = parseInt(list.style.left || '0', 10);
    const newLeft = currentLeft + moveAmount;

    this.renderer.setStyle(list, 'left', `${newLeft}px`);
    this.reAdjust();
  }

  // reAdjust() {
  //   const list = this.tabList.nativeElement;
  //   const wrapper = this.wrapperNav.nativeElement;

  //   const rightScroller = wrapper.previousElementSibling as HTMLElement;
  //   const leftScroller = wrapper.previousElementSibling.previousElementSibling;

  //   const totalListWidth = this.widthOfList();
  //   const wrapperWidth = wrapper.offsetWidth;
  //   const listRight = list.getBoundingClientRect().right;
  //   const wrapperRight = wrapper.getBoundingClientRect().right;

  //   if (totalListWidth > wrapperWidth && listRight > wrapperRight) {
  //     this.renderer.setStyle(rightScroller, 'display', 'flex');
  //   } else {
  //     this.renderer.setStyle(rightScroller, 'display', 'none');
  //   }

  //   if (this.getLeftPos() < 0) {
  //     this.renderer.setStyle(leftScroller, 'display', 'flex');
  //   } else {
  //     this.renderer.setStyle(leftScroller, 'display', 'none');
  //   }
  // }

  reAdjust() {
    const list = this.tabList.nativeElement;
    const wrapper = this.wrapperNav.nativeElement;

    const rightScroller = wrapper.previousElementSibling as HTMLElement;
    const leftScroller = wrapper.previousElementSibling ? wrapper.previousElementSibling.previousElementSibling as HTMLElement: '';

    const totalListWidth = this.widthOfList();
    const wrapperWidth = wrapper.offsetWidth;
    const listRight = list.getBoundingClientRect().right;
    const wrapperRight = wrapper.getBoundingClientRect().right;

    const currentLeft = parseInt(list.style.left || '0', 10);

    // 👉 Show right scroll button if total list is wider than wrapper
    if (totalListWidth + currentLeft > wrapperWidth) {
      this.renderer.setStyle(rightScroller, 'display', 'flex');
    } else {
      this.renderer.setStyle(rightScroller, 'display', 'none');
    }

    // 👉 Show left scroll button if current left position is less than 0 (meaning some part hidden on left)
    if (currentLeft < 0) {
      this.renderer.setStyle(leftScroller, 'display', 'flex');
    } else {
      this.renderer.setStyle(leftScroller, 'display', 'none');
    }
  }

  setActiveTab(index: number) {
    this.activeIndex = index;
  }
}
